import { RefObject } from 'react';

export const scrollToTop = (ref?: RefObject<HTMLElement> | null): void => {
  if (typeof window !== 'undefined') {
    if (ref?.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
